import React from 'react';

import { TravelSymbol } from 'app/components/TravelSymbol';
import { PageHeader } from '../PageHeader';

import { TravelCalculationViewPageHeaderProps } from './TravelCalculationViewPageHeader.interface';
import { LabelEnum } from 'app/shared/enums';
import { useStyles } from './TravelCalculationViewPageHeader.styles';

export default function TravelCalculationViewPageHeader(
  props: TravelCalculationViewPageHeaderProps
) {
  const classes = useStyles();

  return (
    <PageHeader
      title={LabelEnum.TravelInsurance}
      secondTitle={LabelEnum.TravelInsuranceSecondTitle}
      renderAddon={TravelSymbol}
      className={classes.root}
    />
  );
}
